import React from "react";
import { Checkbox, Collapse } from "antd";
import styled from "styled-components";

const RequirementCheckboxes = ({
  items = [],
  completedItems = [],
  onChange = () => {},
  title = "",
  completedText = "completed",
}) => {
  const totalItems = items.length;
  const completedCount = items.filter((item) =>
    completedItems.includes(item.id)
  ).length;

  const collapseItems = [
    {
      key: "1",
      label: (
        <StyledLabel>
          {title} ({completedCount}/{totalItems} {completedText})
        </StyledLabel>
      ),
      children: (
        <CheckboxGroup>
          {items.map((item) => (
            <StyledCheckbox
              key={item.id}
              checked={completedItems.includes(item.id)}
              onChange={(e) => onChange(item.id, e.target.checked)}
            >
              {item.label}
            </StyledCheckbox>
          ))}
        </CheckboxGroup>
      ),
    },
  ];

  return (
    <Collapse
      style={{ minWidth: "350px", marginBottom: "14px" }}
      items={collapseItems}
    />
  );
};

const StyledLabel = styled.div`
  color: #ffff00;
  font-family: "Chakra Petch", sans-serif;
  font-weight: 500;
`;

const CheckboxGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
`;

const StyledCheckbox = styled(Checkbox)`
  margin-right: 8px;
`;

export default RequirementCheckboxes;
